export const newTask = (onTodoAdded, onDelete, existingData = null) => {
    const mainDiv = document.createElement('div');
    mainDiv.className = 'popup-div';
    const windowDiv = document.createElement('div');
    windowDiv.className = 'task-window';

    // header
    const header = document.createElement('div');
    header.className = 'task-window-header';
    const headerText = document.createElement('h1');
    headerText.textContent = 'Create Form'
    const closeButtonContainer = document.createElement('div');
    closeButtonContainer.className = 'close-btn-container'
    const crossButton = document.createElement('button');
    crossButton.className = 'close-btn';
    crossButton.textContent = '✕';
    crossButton.type = 'button';
    crossButton.addEventListener('click', () => {
        mainDiv.remove();
    });
    closeButtonContainer.appendChild(crossButton);
    header.appendChild(headerText);
    header.appendChild(closeButtonContainer);

    // form
    const form = document.createElement('form');
    form.className = 'todo-form';
    form.innerHTML = `
    <label>Title: 
        <input type="text" name="title" required>
    </label>
    <label>
        Description: <textarea name="description" rows="3"></textarea>
    </label>
    <label>
        Due Date: <input type="datetime-local" name="dueDate" required>
    </label>
    <label>Priority:
        <select name="priority">
            <option value="low">Low</option>
            <option value="medium">Medium</option>
            <option value="high">High</option>
        </select>
    </label>
    `;

    if (existingData) {
        form.querySelector('input[name="title"]').value = existingData.title;
        form.querySelector('textarea[name="description"]').value = existingData.description;
        if (existingData.dueDate) {
            const date = new Date(existingData.dueDate);
            const offset = date.getTimezoneOffset() * 60 * 1000; // offset in milliseconds
            const localValue = new Date(date - offset).toISOString().slice(0, 16);
            form.querySelector('input[name="dueDate"]').value = localValue;
        }
        form.querySelector('select[name="priority"]').value = existingData.priority || 'low';
    }
    
    // form submission
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        const formData = new FormData(form);
        const data = {
            title: formData.get('title'),
            description: formData.get('description'),
            dueDate: formData.get('dueDate'),
            priority: formData.get('priority')
        };
        if (onTodoAdded) onTodoAdded(data);
        mainDiv.remove();
        
    }); 
    
    // footer
    const footer = document.createElement('div');
    footer.className = 'task-window-footer';
    // submit button
    const submitButton = document.createElement('button');
    submitButton.type = 'submit';
    submitButton.className = 'submit-button';
    submitButton.textContent = existingData ? 'Update' : 'Submit';
    footer.appendChild(submitButton);
    // delete button
    const deleteButton = document.createElement('button');
    deleteButton.type = 'button';
    deleteButton.className = 'delete-button';
    deleteButton.textContent = 'Delete';
    deleteButton.addEventListener('click', (e) => {
        e.stopPropagation();
        if (onDelete) onDelete();
        mainDiv.remove();
    });
    footer.appendChild(deleteButton);
    form.appendChild(footer);
    
    // final appending
    windowDiv.appendChild(header);
    windowDiv.appendChild(form);
    mainDiv.appendChild(windowDiv);
    
    return mainDiv;
}